import { AssetFile } from 'contentful';
import NextImage, { ImageLoaderProps } from 'next/image';
import { Source } from '../../../../components/NextImage/Source';
import {
  ContentfulResizeTypes,
  getContentfulLoader,
} from '../../../../helpers/imageLoaders/contentful';

interface IProps {
  bannerTitle: string;
  bannerDesktop: AssetFile;
  bannerMobile?: AssetFile;
  bannerTablet?: AssetFile;
}

const ASPECT_RATIO_MOBILE = { width: 376, height: 392 };
const ASPECT_RATIO_TABLET = { width: 769, height: 316 };
const ASPECT_RATIO_DESKTOP = { width: 1280, height: 433 };

export const CMSBannerImage = ({
  bannerTitle,
  bannerDesktop,
  bannerMobile,
  bannerTablet,
}: IProps) => {
  return (
    <picture>
      <Source
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(src, width, ASPECT_RATIO_DESKTOP.width, ASPECT_RATIO_DESKTOP.height, {
            quality,
            resize: ContentfulResizeTypes.FILL,
          })
        }
        media="(min-width: 900px)"
        src={bannerDesktop.url}
      />
      <Source
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(src, width, ASPECT_RATIO_TABLET.width, ASPECT_RATIO_TABLET.height, {
            quality,
            resize: ContentfulResizeTypes.FILL,
          })
        }
        media="(min-width: 600px)"
        src={bannerTablet?.url ?? bannerDesktop.url}
      />
      <NextImage
        className="w-full object-cover"
        src={bannerMobile?.url ?? bannerDesktop.url}
        width={ASPECT_RATIO_MOBILE.width}
        height={ASPECT_RATIO_MOBILE.height}
        loader={({ src, width, quality }: ImageLoaderProps): string =>
          getContentfulLoader(src, width, ASPECT_RATIO_MOBILE.width, ASPECT_RATIO_MOBILE.height, {
            quality,
            resize: ContentfulResizeTypes.FILL,
          })
        }
        alt={bannerTitle}
        sizes="(min-width: 1280px) 1280px, 100vw"
      />
    </picture>
  );
};
